import { Component, ViewChild } from '@angular/core';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-container-generic',
  templateUrl: './modal-container-generic.component.html',
  styleUrls: ['./modal-container-generic.component.scss'],
})
export class ModalContainerGenericComponent {
  @ViewChild('modal', { static: true }) public modal: ModalDirective;
  private readonly modalOptions: ModalOptions = new ModalOptions();

  show(confirmationClose?: boolean): this {
    this.modalOptions.ignoreBackdropClick = true;
    this.modalOptions.keyboard = true;
    this.modal.config = this.modalOptions;
    this.modal.show();
    return this;
  }

  hide() {
    this.modal.hide();
  }
}
